import { Entity } from "../core/entity";
var Type;
(function (Type) {
    Type["REGULAR"] = "regular";
    Type["DELETED"] = "deleted";
})(Type || (Type = {}));
export class StreamMessagePayload extends Entity {
    get content() {
        return this.dto.text || "";
    }
    get userId() {
        return this.dto?.user?.id ?? "";
    }
    get userName() {
        return this.dto?.user?.name ?? "";
    }
    get userImage() {
        return this.dto?.user?.image;
    }
    isDeleted() {
        return this.dto?.type === Type.DELETED;
    }
    /**
     * Returns message sender name. If not present, defaults to user id.
     */
    getUserName() {
        return this.userName || this.id;
    }
}
